module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "company-edit"
  }, [_c('modal', {
    staticClass: "edit-company-modal",
    attrs: {
      "title": "",
      "open": _vm.isOpen
    },
    on: {
      "save": function($event) {
        return _vm.save()
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "required": "",
      "name": "name",
      "label": _vm.$t('ui.company.fields.name'),
      "autofocus": true
    },
    model: {
      value: (_vm.workingCompany.name),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany, "name", $$v)
      },
      expression: "workingCompany.name"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "website",
      "label": _vm.$t('ui.company.fields.website')
    },
    model: {
      value: (_vm.workingCompany.website),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany, "website", $$v)
      },
      expression: "workingCompany.website"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "street",
      "label": _vm.$t('ui.company.fields.street')
    },
    model: {
      value: (_vm.workingCompany.address.street),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany.address, "street", $$v)
      },
      expression: "workingCompany.address.street"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "number",
      "label": _vm.$t('ui.company.fields.street_number')
    },
    model: {
      value: (_vm.workingCompany.address.street_number),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany.address, "street_number", $$v)
      },
      expression: "workingCompany.address.street_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "city",
      "label": _vm.$t('ui.company.fields.city')
    },
    model: {
      value: (_vm.workingCompany.address.city),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany.address, "city", $$v)
      },
      expression: "workingCompany.address.city"
    }
  }), _vm._v(" "), _c('field', {
    staticClass: "field",
    attrs: {
      "type": "text",
      "name": "zip",
      "label": _vm.$t('ui.company.fields.postcode')
    },
    model: {
      value: (_vm.workingCompany.address.zip),
      callback: function($$v) {
        _vm.$set(_vm.workingCompany.address, "zip", $$v)
      },
      expression: "workingCompany.address.zip"
    }
  })], 1), _vm._v(" "), _c('country-select', {
    staticClass: "field",
    attrs: {
      "value": _vm.workingCountry,
      "type": "text",
      "params": {
        favorites: ['DE']
      },
      "name": "country",
      "label": _vm.$t('ui.company.fields.country')
    },
    on: {
      "input": function($event) {
        return _vm.setCountry($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2075c258","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/companies/CompanyEdit.vue
// module id = 1836
// module chunks = 0